import client from './main-client';

export const fetchRateMarketingInputsApi = (params) => client().get('/rate-marketing-inputs', { params });

export const addOrUpdateRateMarketingInputsApi = (data) => client().post('/rate-marketing-inputs', data); // Accepts array of objects
